/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PreferredLanguageDto } from '../../models/preferred-language-dto';
import { UpdateLanguageRequest } from '../../models/update-language-request';

export interface UpdatePreferredLanguage$Params {
      body: UpdateLanguageRequest
}

export function updatePreferredLanguage(http: HttpClient, rootUrl: string, params: UpdatePreferredLanguage$Params, context?: HttpContext): Observable<StrictHttpResponse<PreferredLanguageDto>> {
  const rb = new RequestBuilder(rootUrl, updatePreferredLanguage.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PreferredLanguageDto>;
    })
  );
}

updatePreferredLanguage.PATH = '/i18n/preferred-language';
